import { DashboardHeader } from "./components/DashboardHeader";
import { ShippingDashboard } from "./components/ShippingDashboard";
import { ServicePlaceholder } from "./components/ServicePlaceholder";

export default function App() {
  return (
    <main className="min-h-screen w-full bg-midnight">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-1 bg-nextx-gradient"
      />
      <DashboardHeader title="Shipping" />
      <ShippingDashboard />
      <ServicePlaceholder />
    </main>
  );
}
